import script from "./DesktopHotspotDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./DesktopHotspotDetails.vue?vue&type=script&lang=ts&setup=true"

import "./DesktopHotspotDetails.vue?vue&type=style&index=0&id=f45b60ae&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src462465770/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f45b60ae"]])

export default __exports__